import { render } from "./CompanyProgrammesResponsiveList.vue?vue&type=template&id=0f2651b6&scoped=true"
import script from "./CompanyProgrammesResponsiveList.vue?vue&type=script&lang=js"
export * from "./CompanyProgrammesResponsiveList.vue?vue&type=script&lang=js"

import "./CompanyProgrammesResponsiveList.vue?vue&type=style&index=0&id=0f2651b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2651b6"]])

export default __exports__